// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19xyO","type":"styles_type__2P08P","choices":"styles_choices__1ZeI7"};